<div class="text-center ready-set-container">
	<h2 class="ready-set-header">Ready. Set. RegScale.</h2>
	<p class="mt-4 ready-set-content">
		RegScale helps you stay continuously compliant with the vast number of
		growing regulations that govern your organization and industry - all in
		real-time.
	</p>

	<button class="mt-4 ready-set-btn bg-white py-2 px-5" (click)="getStarted()">
		Get Started Today
	</button>
</div>
